<template>
  <div class="list-box">
    <p class="news-p">我院积极收听收看十三届全国人大三次会议开幕式</p>
    <div class="news-box">
      <div class="box-item">
        <p class="list-textP">5月22日，我院积极收听收看十三届全国人大积极收听收看十三届全国人大三十三届全国…</p>
        <div class="list-bottom">
          <img src="@/images/read_icon.png" />
          <span class="list-num">129</span>
          <span class="list-right">2020-05-22</span>
        </div>
      </div>
      <div class="box-item1">
        <img class="right-img" src="@/images/doctor.png" />
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/reset.css';
@import '../../../assets/stylus/theme.styl';

.van-tabs__line {
  background-color: $main-bgColor;
}

.list-box {
  padding: 10px;

  .news-p {
    color: #353535;
    font-size: 15px;
    padding: 10px 0;
    font-weight: 700;
  }

  .news-box {
    display: flex;

    .box-item1 {
      text-align: right;
      width: 20%;
      margin-left: 10px;

      .right-img {
        width: 100%;
      }
    }

    .box-item {
      flex: 1;

      .list-textP {
        color: #888888;
        font-size: 13px;
        line-height: 18px;
      }

      .right-img {
        width: 52%;
      }

      .list-bottom {
        color: #CACAD2;
        font-size: 12px;
        position: relative;

        .list-num {
          vertical-align: middle;
        }

        .list-right {
          position: absolute;
          top: 1vw;
          bottom: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
}
</style>